export default "__VITE_ASSET__DKMpqDiG__"